import { render, staticRenderFns } from "./full-video.component.vue?vue&type=template&id=4f3b351a&"
import script from "./full-video.component.vue?vue&type=script&lang=js&"
export * from "./full-video.component.vue?vue&type=script&lang=js&"
import style0 from "./full-video.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports